import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';

export interface LoaderProps {
    loading: boolean;
}

export const Loader: FunctionComponent<LoaderProps> = observer(({loading}) =>
    loading ? <div className="loader">Loading...</div> : <React.Fragment/>);
